<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import WppConnectForm from './WppConnectForm.vue';
import CommonWhatsappAPI from './commonWhatsapp/api';
import CommonWhatsappForm from './commonWhatsapp/CommonWhatsappForm.vue';
import { useAlert } from 'dashboard/composables';

export default {
  components: {
    PageHeader,
    WppConnectForm,
    CommonWhatsappForm,
  },
  data() {
    return {
      player: '',
    };
  },
  mounted() {
    this.getCurrentPlayer();
  },
  methods: {
    async getCurrentPlayer() {
      const { data } = await CommonWhatsappAPI.getCurrentPlayer();
      if (!data || !data.player) {
        useAlert('Integração com Whatsapp indisponível no momento');
        return;
      }
      this.player = data.player;
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP.DESC')"
    />

    <span v-if="!player" class="spinner" />
    <WppConnectForm v-if="player === 'wppconnect'" />
    <CommonWhatsappForm v-if="player === 'codechat'" />
  </div>
</template>
